import { companyConstants } from "../actions/company/index";

const defaultState = {
  status: {
    started: false,
    error: false,
    ended: false,
    errorInfo: {
      code: "",
      message: ""
    }
  }
};

export default function usersList(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case companyConstants.GET_USERS_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      },
      isGettingUsers: true,
      user: null
    };
  case companyConstants.GET_USERS_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      isGettingUsers: false,
      ...payload
    };
  case companyConstants.GET_USERS_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      },
      isGettingUsers: false
    };
  default:
    return defaultS;
  }
}
